/**
 * Optional numeric form fields are held as strings so an empty input
 * stays empty instead of collapsing to 0 — the difference matters
 * throughout this module, where 0 is a real value (no minimum time, no
 * technical judge) and "unset" means something else entirely.
 */

/** Form string → payload value. Empty means "clear this bound". */
export function optionalNumber(value: string): number | null {
  const trimmed = value.trim();
  return trimmed === "" ? null : Number(trimmed);
}

/** Payload value → form string. */
export function numberField(value: number | null | undefined): string {
  return value === null || value === undefined ? "" : String(value);
}

/** True when a required numeric field holds something usable. */
export function isPositiveInteger(value: string): boolean {
  return /^\d+$/.test(value.trim()) && Number(value) > 0;
}

/** True when an optional numeric field is either empty or a number. */
export function isOptionalInteger(value: string): boolean {
  return value.trim() === "" || /^\d+$/.test(value.trim());
}
